import FingerprintJS from "@fingerprintjs/fingerprintjs"

// Identifies the tablet for the admin device list (ADR-025's missing device
// name), never to authenticate it. Null when the browser can't be fingerprinted,
// and the request goes without: nothing the kiosk does may depend on it.
async function fingerprint(): Promise<string | null> {
  try {
    const agent = await FingerprintJS.load({ monitoring: false })
    return (await agent.get()).visitorId
  } catch {
    return null
  }
}

// Probing canvas, audio and WebGL is slow on a modest tablet, so it is done once
// per page load rather than on every tap. A failure is held too: the kiosk
// reloads when it goes idle, which is retry enough.
let held: Promise<string | null> | undefined

// The header to send, or none when the tablet couldn't be fingerprinted.
export async function fingerprintHeader(): Promise<Record<string, string>> {
  held ??= fingerprint()
  const visitorId = await held
  return visitorId ? { "X-Kiosk-Fingerprint": visitorId } : {}
}
